import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Searchable dropdown. Options with data-email render as avatar + name + email (client picker).
export default class extends Controller {
  connect() {
    this.select = new TomSelect(this.element, {
      allowEmptyOption: true,
      maxOptions: null,
      plugins: ["dropdown_input"],
      render: { option: (data, escape) => this.option(data, escape) }
    })
  }

  disconnect() {
    this.select?.destroy()
    this.select = null
  }

  option(data, escape) {
    const email = data.email || data.$option?.dataset.email
    if (!email) return `<div>${escape(data.text)}</div>`

    const initials = data.text.split(/\s+/).slice(0, 2).map((word) => word[0]).join("").toUpperCase()
    return `<div class="flex items-center gap-3">
      <span class="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-brand-50 text-[11px] font-semibold text-brand-700">${escape(initials)}</span>
      <span class="min-w-0 flex-1"><span class="block truncate text-slate-800">${escape(data.text)}</span><span class="block truncate text-xs text-slate-500">${escape(email)}</span></span>
    </div>`
  }
}
